module.exports = __webpack_public_path__ + "img/boston.89cb75b6.png";